module.exports = __webpack_public_path__ + "static/img/ooshzonelogo.80283d9.png";


//////////////////
// WEBPACK FOOTER
// ./static/logos/ooshzonelogo.png
// module id = Urcs
// module chunks = 170